<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
  </section>
</template>
<script>
import {
  getViolation,
} from 'api/car';
import {
  getFileUrl,
} from 'api';
export default {
  components: {
  },
  data () {
    return {
      title: '查看违章详情',
      loading: false,
      detailData: {
        base: {
          label: '违章信息',
          tableData: {
            title: [
              { prop: 'plateNumber', label: '车牌号码' },
              { prop: 'orgName', label: '车辆归属' },
              { prop: 'categoryIdName', label: '违章类型' },
              { prop: 'violationTime', label: '违章时间' },
              { prop: 'locationName', label: '违章城市' },
              { prop: 'violationAddress', label: '违章地点' },
              { prop: 'violationCode', label: '违章代码' },
              { prop: 'violationFine', label: '罚金（元）' },
              { prop: 'overdueFine', label: '滞纳金（元）' },
              { prop: 'violationPoint', label: '扣分数' },
              { prop: 'serviceProvider', label: '服务商' },
              { prop: 'payAmt', label: '成交价（元）' },
              { prop: 'violationReason', label: '违章行为' },
              { prop: 'personLiable', label: '责任人' },
              { prop: 'recordStateName', label: '是否已处理' },
              { prop: 'remark', label: '备注' },
              // { prop: 'picList', label: '上传图片' },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/maintain/violation/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await getViolation({
        recordId: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        // 重置一下展示的字段长度，防止来回切换 tab 的时候图片字段不断增多
        const insertIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'remark') + 1;
        this.detailData.base.tableData.title.length = insertIndex;
        // 获取图片 id 然后去请求另外一个接口获取图片url地址
        if (detailRes.picList && detailRes.picList.length) {
          let flowIds = [];
          for (let i = 0; i < detailRes.picList.length; i++) {
            flowIds.push(detailRes.picList[i].fileId);
            this.detailData.base.tableData.title.push({
              prop: 'pic' + i,
              label: '上传图片' + (i || ''),
              type: 'img',
            });
          }

          const imgRes = await getFileUrl({
            flowIds: flowIds.join(),
          });

          for (let i = 0; i < detailRes.picList.length; i++) {
            imgRes.items.forEach((item) => {
              if (item.flowId === detailRes.picList[i].fileId) {
                detailRes['pic' + i] = item.fullPath;
              }
            });
          }
        } else {
          this.detailData.base.tableData.title.push({
            prop: 'pic',
            label: '上传图片',
            type: 'img',
          });
        }
        this.detailData.base.tableData.data = detailRes;
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style>
</style>
